(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl-flavors"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change', function(event) {
  const selected = event.target;

  if (!selected.matches('.pl-products__pack-option input[type="radio"]')) {
    return;
  }

  const card = selected.closest('.pl-products__card');

  if (!card) return;

  const form = card.querySelector('.pl-products__quick-form');
  const button = card.querySelector('.pl-products__quick-add');
  const icon = card.querySelector('.pl-products__quick-icon');

  if (!form || !button || !icon) return;

  form.querySelector('input[name="id"]').value = selected.dataset.variantId;

  card.querySelector('[data-pack-price]').textContent = selected.dataset.price;
  card.querySelector('[data-pack-unit-price]').textContent =
    selected.dataset.unitPrice + '/pacote';
  card.querySelector('[data-pack-meta]').textContent = selected.dataset.meta;

  const compare = card.querySelector('[data-pack-compare]');
  compare.textContent = selected.dataset.compare || '';
  compare.hidden = !selected.dataset.compare;

  const saving = card.querySelector('[data-pack-saving]');
  saving.textContent = selected.dataset.saving
    ? 'Economize ' + selected.dataset.saving + ' na caixa'
    : '';
  saving.hidden = !selected.dataset.saving;

  button.disabled = selected.dataset.available !== 'true';
  button.setAttribute(
    'aria-label',
    'Adicionar ' + selected.dataset.label + ' ao carrinho'
  );

  icon.textContent = button.disabled ? '×' : '+';

  const media = card.querySelector('.pl-products__media');
  const title = card.querySelector('.pl-products__title a');

  if (media) media.href = selected.dataset.productUrl;
  if (title) title.href = selected.dataset.productUrl;

  const image = card.querySelector('.pl-products__image');

  if (image && selected.dataset.imageUrl) {
    image.removeAttribute('srcset');
    image.src = selected.dataset.imageUrl;
    image.alt = selected.dataset.label;
  }
});

document.addEventListener('submit', async function(event) {
  const form = event.target.closest('.pl-products__quick-form');

  if (!form) return;

  event.preventDefault();

  const button = form.querySelector('.pl-products__quick-add');
  const icon = form.querySelector('.pl-products__quick-icon');

  if (!button || button.disabled) return;

  button.disabled = true;

  try {
    const formData = new FormData(form);

    const response = await fetch(
      (window.Shopify?.routes?.root || '/') + 'cart/add.js',
      {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        },
        body: formData
      }
    );

    if (!response.ok) {
      throw new Error();
    }

    icon.textContent = '✓';

    document.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true
      })
    );

    setTimeout(function() {
      icon.textContent = '+';
      button.disabled = false;
    }, 1000);
  } catch (error) {
    icon.textContent = '!';

    setTimeout(function() {
      icon.textContent = '+';
      button.disabled = false;
    }, 1100);
  }
});

  } catch(e) { console.error(e); }
})();
})();
